module.exports = __webpack_public_path__ + "media/images/Contact-blue-30eca17e65a79be9237db306eb0fb724.svg";